const ROOM_KEY = "de-vurige-stand-room";

export const getStoredRoom = (): string | null => localStorage.getItem(ROOM_KEY);

export const setStoredRoom = (room: string) => localStorage.setItem(ROOM_KEY, room);

export const clearStoredRoom = () => localStorage.removeItem(ROOM_KEY);
